import store from 'store'
import { Base64 } from 'js-base64'

import { getStore } from '../store'
import { logout } from 'actions'
import { resetStore } from 'libs/connectApi'
import constants from 'config/constants'
import { postLogin, createUser, getDemoLogin } from '../api'
import { cache } from 'hooks/useAxios'

const auth = {
  login(username, password) {
    return postLogin({
      username,
      password,
    }).then((response) => {
      if (response.require_sso) {
        const requireSSO = Boolean(response.require_otp)
        return {
          isAuthenticated: false,
          error: {
            sso: true,
          },
          requireSSO,
        }
      } else if (response.error && response.available_login_methods) {
        return {
          isAuthenticated: false,
          error: {
            noLoginMethodAvailable: true,
          },
          availableLoginMethods: response.available_login_methods,
        }
      } else if (response.token) {
        const requireOtp = Boolean(response.require_otp)
        if (!requireOtp) {
          store.set(constants.simplesatTokenName, response.token)
        }
        return { isAuthenticated: true, requireOtp, token: response.token }
      } else {
        return {
          isAuthenticated: false,
          error: {
            login: true,
          },
        }
      }
    })
  },

  demoLogin() {
    return getDemoLogin().then((response) => {
      store.set(constants.simplesatTokenName, response.token)
      return { isAuthenticated: true, requireOtp: false, token: response.token }
    })
  },

  setToken(token) {
    store.set(constants.simplesatTokenName, token)
  },

  isLoggedIn() {
    const hasToken = !!store.get(constants.simplesatTokenName)
    return hasToken
  },

  getToken() {
    return store.get(constants.simplesatTokenName)
  },

  logout() {
    store.clearAll()
    getStore().dispatch(logout())
    getStore().dispatch(resetStore())
    cache.clear()
  },

  signup(userInfo) {
    return createUser(userInfo).then((res) => {
      if (res.token) {
        store.set(constants.simplesatTokenName, res.token)
        return { isAuthenticated: true }
      } else if (res.status === 409) {
        store.remove(constants.simplesatTokenName)
        return {
          isAuthenticated: false,
          error: { signup: true },
        }
      } else if (res.status === 403) {
        store.remove(constants.simplesatTokenName)
        return {
          isAuthenticated: false,
          error: { blacklist: true },
        }
      } else {
        store.remove(constants.simplesatTokenName)
        return {
          isAuthenticated: false,
          error: { other: true },
        }
      }
    })
  },

  getUserInfoFromToken() {
    const token = auth.getToken()
    if (token) {
      try {
        return JSON.parse(Base64.decode(token.split('.')[1]))
      } catch (e) {
        return {}
      }
    }

    return {}
  },

  isDemoUser() {
    const userInfo = auth.getUserInfoFromToken()
    return userInfo.user_id === parseInt(constants.demoUserId)
  },
}
export default auth



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/auth/index.js